/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/to_geotile.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Converts an input value to a `geotile` value.
 * A string will only be successfully converted if it respects the
 * `geotile` format, as described for the
 * geotile grid aggregation.
 *
 * @example
 * ROW string = "4/8/5"
 * | EVAL geotile = TO_GEOTILE(string)
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'to_geotile',
  signatures: [
    {
      params: [
        {
          name: 'field',
          type: 'geotile',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'geotile',
    },
    {
      params: [
        {
          name: 'field',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'geotile',
    },
    {
      params: [
        {
          name: 'field',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'geotile',
    },
    {
      params: [
        {
          name: 'field',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'geotile',
    },
  ],
  preview: true,
  snapshotOnly: false,
};

export default definition;
